export const getDefaultColor = user => {
	return user.isSwiftVersion ? 'def0-46' : 'def0-1';
};
